import { render, staticRenderFns } from "./ConstructionWorkStoppage.vue?vue&type=template&id=f362c874&scoped=true&"
import script from "./ConstructionWorkStoppage.vue?vue&type=script&lang=js&"
export * from "./ConstructionWorkStoppage.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionWorkStoppage.vue?vue&type=style&index=0&id=f362c874&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f362c874",
  null
  
)

export default component.exports